export const enum HotelDetailsModalType {
  Amenitites = 'amenitites',
  FullHotelDetailsDescription = 'fullHotelDetailsDescription',
  FullDestinationDescription = 'fullDestinationDescription',
  None = 'none',
  PriceBreakdown = 'priceBreakdown',
  PriceGuarantee = 'priceGuarantee',
}
